
  import { Component, Prop, Watch } from 'vue-property-decorator'
  import { ContentBase } from '@/components/forms/inspection/steppers/content/ContentBase'
  import { sortArray } from '@/utils/array/manipulation'
  import { Debounce } from '@/utils/decorators'
  import { Component as CategoryComponent } from '@/entities/vehicle'
  import RowData from '@/components/forms/inspection/supervisor/components/RowData.vue'
  import { isValidNumber } from '@/utils/general'

@Component({
  components: { RowData },
  methods: {
    isValidNumber,
    sortArray,
  },
})
  export default class BasicEquipmentContent extends ContentBase {
  @Prop({ type: Object }) keyComponent: CategoryComponent
  items = []
  fieldsKeys = ['status']

  formData = {
    status: {
      answer: null,
      provisional: false,
    },
    copy: {
      answer: null,
    },
    cost: undefined,
    supervisorCost: undefined,
    photo: null,
  }

  errorIdentifierMessage = ''

  loadingFile (flag) {
    this.isUploadingFile = flag
  }

  async send () {
    const { formData, keyComponent, inspection } = this

    if (formData.cost && (formData.supervisorCost === null || formData.supervisorCost === undefined)) {
      this.errorIdentifierMessage = 'El costo es requerido'
      return false
    } else {
      this.errorIdentifierMessage = ''
    }

    const matchingInspectedComponent = inspection.inspectedComponents.find(
      ic => ic.inspectionComponent.id === keyComponent?.inspectionComponent?.id
    )
    if (matchingInspectedComponent) {
      await this.updateInspectionQualificationValidated(matchingInspectedComponent.findInspectionQualificationByOrder(1)?.[0]?.id)

      if (formData?.supervisorCost) {
        await this.pushData({
          model: 'InspectionInspectedComponent',
          fields: { id: matchingInspectedComponent.id, supervisor_cost: formData.supervisorCost || 0 },
        })
      }
    }

    return parseInt(formData.supervisorCost) || 0
  }

  @Watch('keyComponent', { immediate: true, deep: true })
  @Debounce(100)
  async onComponentsChange (val) {
    const { idProcess, inspection } = this

    const matchingInspectedComponent = inspection.inspectedComponents.find(
      ic => ic.inspectionComponent.id === val?.inspectionComponent?.id
    )

    if (matchingInspectedComponent) {
      this.formData.photo = await this.fetchData({
        query: { name: 'find', model: 'FileProcess' },
        filter: {
          _and: [
            { id_process_record: { _eq: matchingInspectedComponent.id } },
            { parameter: { process: { id: { _eq: idProcess } } } },
            { parameter: { file_type: { name: { _eq: 'photo' } } } },
          ],
        },
        force: true,
      })

      this.processFormData('status', 1, matchingInspectedComponent)
      this.formData.cost = matchingInspectedComponent.cost
      this.formData.supervisorCost = matchingInspectedComponent.supervisorCost || matchingInspectedComponent.cost
      this.$emit('input', { total: this.formData.cost })
      this.formData.copy.answer = matchingInspectedComponent?.findInspectionQualificationByOrder(2)?.[0]?.assessment?.id
      if (matchingInspectedComponent.cost) {
        this.cost = true
      }
    }

    if ((this.formData.status.provisional === false && this.formData.status.answer) || (this.formData.status.provisional)) {
      this.$emit('next')
    }
  }

  processFormData (field, order, component) {
    const param = component.findInspectionParameterByOrder(order)
    const qual = component.findInspectionQualificationByOrder(order)

    if (!param?.assessment?.score) {
      this.formData[field].provisional = param?.assessment?.id
      this.formData[field].answer = null
    } else {
      this.formData[field].provisional = false
      this.formData[field].answer = qual.map(item => item.assessment.id)
    }
  }

  get displayPhoto () {
    const { keyComponent, formData: { copy }, getQuestionOptions } = this
    if (!copy?.answer) return false

    return !getQuestionOptions(keyComponent, 2).find(item => item.id === copy.answer)?.score
  }

  get isOnlyOnceKey () {
    const { keyComponent, formData: { copy }, getQuestionOptions } = this
    if (!copy?.answer) return false

    return getQuestionOptions(keyComponent, 2).find(item => item.id === copy.answer)?.score
  }
  }
